module.exports = __webpack_public_path__ + "static/media/edit_disable.54d71c59.svg";